import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Button } from "main/javascripts/components/atoms/Button";
import { ModalDialog } from "main/javascripts/components/atoms/Modal/ModalDialog/ModalDialog";
import { ModalTitle } from "main/javascripts/components/atoms/Modal/ModalTitle";
import { ModalDescription } from "main/javascripts/components/atoms/Modal/ModalDescription";
import { Icon } from "main/javascripts/components/atoms/Icon";
import { SelectionModalDialogStyle } from "./SelectionModalDialogStyle";
import { IIconFontStyle } from "main/javascripts/styles/fontStyle";

export interface IProps {
  displayed: boolean;
  hasCostMessage?: boolean;
  selectionType: string;
  closeHandler: any;
  t?: any;
}

const selectionTypeData: {
  [key: string]: {
    title: string;
    description: string;
    iconType: keyof IIconFontStyle;
    button: string;
  };
} = {
  hotel: {
    title: "component:modal.selectionTitle",
    description: "component:modal.selectionDescription",
    iconType: "hotel",
    button: "component:search.close",
  },
  hotelEmail: {
    title: "component:modal.selectionTitle",
    description: "component:modal.selectionEmailDescription",
    iconType: "hotel",
    button: "component:search.close",
  },
  hotelCost: {
    title: "component:modal.selectionTitle",
    description: "component:modal.selectionWitCostDescription",
    iconType: "hotel",
    button: "component:search.confirm",
  },
  flight: {
    title: "component:modal.selectionTitle",
    description: "component:modal.selectionEmailDescription",
    iconType: "airplane",
    button: "component:search.close",
  },
  flightEmail: {
    title: "component:modal.selectionTitle",
    description: "component:modal.selectionEmailDescription",
    iconType: "airplane",
    button: "component:search.close",
  },
  flightCost: {
    title: "component:modal.selectionTitle",
    description: "component:modal.selectionWitCostDescription",
    iconType: "airplane",
    button: "component:search.confirm",
  },
};

class SelectionModalDialogComponent extends React.Component<
  IProps & WithTranslation
> {
  public render(): JSX.Element {
    const { displayed, hasCostMessage, closeHandler, selectionType, t } =
      this.props;
    const selectionText: any = hasCostMessage
      ? selectionTypeData[`${selectionType}Cost`]
      : selectionTypeData[selectionType];
    return (
      <ModalDialog displayed={displayed}>
        <div>
          <div>
            <Icon
              styleKey={selectionTypeData[selectionType].iconType}
              styles={SelectionModalDialogStyle.modalIcon}
            />
            <ModalTitle>
              {t(selectionText.title, {
                type: t(`label:common.${selectionType}`),
              })}
            </ModalTitle>
            <ModalDescription>{t(selectionText.description)}</ModalDescription>
          </div>
          <Button
            styles={{
              block: SelectionModalDialogStyle.modalButton,
            }}
            onClick={closeHandler}
          >
            {t(selectionText.button)}
          </Button>
        </div>
      </ModalDialog>
    );
  }
}

export const SelectionModalDialog: any = withTranslation(["component"])(
  SelectionModalDialogComponent
);
